import Immutable from "immutable";
import { CLEAR_SEARCH_DATA, HASH_CHANGED } from "../../common/hash/actions";
import {
	SEARCH_GET_RESULT,
	SEARCH_RESULT,
	SEARCH_RESULT_FAILED,
} from "../result/actions";

const initialState = Immutable.Map({
	counts: undefined,
	valid: true,
	loading: false,
	error: false,
});

export const previewReducer = (state = initialState, action) => {
	switch (action.type) {
		case SEARCH_GET_RESULT:
			return state.merge({
				loading: true,
				error: false,
			});
		case SEARCH_RESULT:
			return state.merge({
				counts: Immutable.Map(action.data.result.paging),
				loading: false,
				error: false,
			});
		case SEARCH_RESULT_FAILED:
			return state.merge({
				counts: undefined,
				valid: true, // To break an infinite loop of server requests if we get an error from the server.
				loading: false,
				error: true,
			});
		case HASH_CHANGED:
			return state.merge({
				valid: false,
				error: false,
			});
		case CLEAR_SEARCH_DATA:
			return state.merge({
				counts: undefined,
				valid: true,
				error: false,
			});
		default:
			return state;
	}
};
